const brandColor = require('@/config/brandColor')

module.exports = {
  data() {
    return {
      getCurrentBrand: {},
    }
  },
  methods: {
    routeFixedParam(param = {}) {
      let query = this.$route.query

      param.brand = query.brand
      param.province = query.province

      if (query.province instanceof Array) {
        param.province = query.province[0]
      }

      if (query.brand instanceof Array) {
        param.brand = query.brand[0]
      }
      return param
    },
    getBrandThemeURL(url) {
      return require(`@/assets/theme/${this.getCurrentBrand.brandKey}/${url}`)
    },
    getCurrentBrandColor() {
      return brandColor[this.getCurrentBrand.brandKey] || brandColor.skb
    },

    setupRecommendCode(query, data) {
      // 获取目标路由的完整 URL 或查询参数
      const rcode = query.rcode || ''

      if (rcode) {
        const rcode_range = data.rcode_range
        const rcode_value = data.rcode_value || query.no

        this.$store.dispatch('recommendCode/setRecommendCode', {
          rcode: rcode,
          rcode_range,
          rcode_value,
        })
      }
    },
  },
  created() {
    this.getCurrentBrand = this.$brandConfig.getCurrentBrand
  },
}
